
export const Page = {
    LOGIN: "login",
    CART: "cart",
    PRODUCT: "product",
}

//enum 클래스를 변경할 수 없도록 얼림
Object.freeze(Page);